import type { FC } from 'react';

type SubmitButtonProps = {
  text: string;
  isSubmitting: boolean;
  disabled: boolean;
  className?: string;
};

export const SubmitButton: FC<SubmitButtonProps> = ({
  text,
  isSubmitting,
  disabled,
  className,
}) => {
  const isDisabled = isSubmitting || disabled;
  const mergedClassName = ['btn-submit cursor-pointer', className].filter(Boolean).join(' ');

  return (
    <button type="submit" className={mergedClassName} disabled={isDisabled}>
      {text}
    </button>
  );
};
